module.exports = __webpack_public_path__ + "img/licesnse1.0d752f86.svg";